import { systemLogger, LogLevel } from 'helpers/systemLogger';

export const reportError = (error, options = {}) => {
  systemLogger({
    level: LogLevel.ERROR,
    error,
    ...options,
  });
};
